import get from 'lodash/get';
import Agents from './Agents/Agents.vue';
import ManageAgents from './Agents/children/Manage/Manage.vue';
import AgentEditor from './Agents/children/Manage/Edit.vue';
import ManageRouting from './Agents/children/Routing/Routing.vue';
import ManageAccess from './Agents/children/Access/Access.vue';
import Dashboard from './Agents/children/Dashboard/Dashboard.vue';
import Customer from './Agents/children/Customer/Customer.vue';
import Notification from './Agents/children/Notification/Notification.vue';
import QuickResponses from './Agents/children/QuickResponses/Manage.vue';
import QuickResponseEditor from './Agents/children/QuickResponses/Edit.vue';
import Status from './Agents/children/Status/Manage.vue';
import Tags from './Tags/Tags.vue';
import Apis from './Apis/ApiManagement.vue';
import Assets from './Assets/Manage.vue';
import AssetEditor from './Assets/Edit.vue';
import Channels from './Channels/Channels.vue';
import Documents from './Documents/Manage.vue';
import SmartDrive from './SmartDrive/SmartDrive/Manage.vue';
import SmartDriveEditor from './SmartDrive/SmartDrive/Edit.vue';
import SmartDriveTab from './SmartDrive/Tab.vue';
import SmartControl from './SmartDrive/SmartControl/index.vue';
import SmartControlManage from './SmartDrive/SmartControl/Manage.vue';
import Rules from './SmartDrive/Rules/index.vue';
import ManageRules from './SmartDrive/Rules/Manage.vue';
import Campaign from './Campaign/Manage.vue';
import CampaignEditor from './Campaign/Edit.vue';
import DocumentEditor from './Documents/Edit.vue';
import KeywordsManagement from '@/components/KeywordsManagement/KeywordsManagement.vue';
import Settings from './Settings.vue';
import MangeTemplates from './Agents/children/MessageTemplate/ManageTemplate.vue';
import Teams from './Teams/Manage.vue';
import TeamEditor from './Teams/Edit.vue';
import Import from './Import/Import.vue';
import store from '@/store';
import featureFlags from '@/store/modules/featureFlags';
import i18next from 'i18next';

import IntegrationRouter from './Integrations/Integrations.router';
import { NON_DELETABLE_TAGS } from '@/constants/tag';

const showSmartDrive = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_SMART_DRIVE', false);
const showCampaign = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_CAMPAIGN', false);
const showSmartControl = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_SMART_CONTROL', false);

const CATEGORIES_DESCRIPTION = function description() {
  return `<p>${i18next.t('settings_tab.categories_tab.categories_service_specialty_description')}</p>
  <p>${i18next.t('settings_tab.categories_tab.categories_keyword_description')}</p>`;
};

const baseResource = '/settings/agents';
const buildResourcePath = (resource) => `${baseResource}/${resource}`;

const rootRoute = {
  path: '/settings',
  name: 'Settings',
  component: Settings,
  meta: {
    auth: true,
  },
};
export default {
  ...rootRoute,
  children: [
    {
      path: 'agents',
      name: 'Settings.Agents',
      props: true,
      component: Agents,
      meta: {
        auth: true,
        resource: buildResourcePath('manage'),
        parentName: rootRoute.name,
        lang_key: 'settings_tab.admin_tab.title',
      },
      children: [
        {
          path: 'manage',
          name: 'Settings.Agents.Manage',
          component: ManageAgents,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('manage'),
            parentName: rootRoute.name,
          },
        },
        {
          path: 'manage/:id',
          name: 'Settings.Agents.Manage.Edit',
          component: AgentEditor,
          props: _ => (store.getters['routing/props']),
          meta: {
            auth: true,
            isEditor: true,
            resource: buildResourcePath('manage/:id'),
            parentName: 'Settings.Agents.Manage',
          },
        },
        {
          path: 'routing',
          name: 'Settings.Agents.Routing',
          component: ManageRouting,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('routing'),
          },
        },
        {
          path: 'access',
          name: 'Settings.Agents.Access',
          component: ManageAccess,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('access'),
          },
        },
        {
          path: 'dashboard',
          name: 'Settings.Agents.Dashboard',
          component: Dashboard,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('dashboard'),
          },
        },
        {
          path: 'customer',
          name: 'Settings.Agents.Customer',
          component: Customer,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('customer'),
          },
        },
        {
          path: 'notification',
          name: 'Settings.Agents.Notification',
          component: Notification,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('notification'),
          },
        },
        {
          path: 'quick_responses',
          name: 'Settings.Agents.QuickResponse',
          component: QuickResponses,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('quick_responses'),
          },
        },
        {
          path: 'message_template',
          name: 'Settings.Agents.Templates',
          component: MangeTemplates,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('message_template'),
          },
        },
        {
          path: 'quick_responses/:id',
          name: 'Settings.Agents.QuickResponse.Edit',
          component: QuickResponseEditor,
          props: true,
          meta: {
            auth: true,
            isEditor: true,
            resource: buildResourcePath('quick_responses/:id'),
            parentName: 'Settings.Agents.QuickResponse',
          },
        },
        {
          path: 'status',
          name: 'Settings.Agents.Status',
          component: Status,
          props: true,
          meta: {
            auth: true,
            resource: buildResourcePath('status'),
          },
        },
      ],
    },
    {
      path: 'teams',
      name: 'Teams',
      component: Teams,
      meta: {
        auth: true,
        resource: '/settings/teams',
        parentName: rootRoute.name,
      },
    },
    {
      path: 'teams/:id',
      component: TeamEditor,
      meta: {
        auth: true,
        resource: '/settings/teams/:id',
        parentName: 'Teams',
      },
    },
    {
      path: 'channels',
      name: 'Channels',
      component: Channels,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'tags',
      name: 'Tags',
      component: Tags,
      props: {
        type: 'tag',
        title: 'Tags',
        minimumAllowedKewords: 0,
        isSystemKeyword: (item) => NON_DELETABLE_TAGS.includes(item.name),
      },
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'categories',
      name: 'Categories',
      component: KeywordsManagement,
      props: {
        type: 'category',
        title: 'Categories',
        description: CATEGORIES_DESCRIPTION,
      },
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'assets',
      name: 'Assets',
      component: Assets,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'assets/:id',
      component: AssetEditor,
      meta: {
        auth: true,
        resource: '/settings/assets/:id',
        parentName: 'Assets',
      },
    },
    ...(showSmartDrive ? [
      {
        path: 'smartdrive',
        name: 'Smart Drive',
        component: SmartDriveTab,
        meta: {
          auth: true,
          parentName: rootRoute.name,
        },
        children: [
          {
            path: '',
            name: 'Smart Drive List',
            component: SmartDrive,
            meta: {
              auth: true,
              parentName: rootRoute.name,
            },
          },
          {
            path: ':id',
            component: SmartDriveEditor,
            meta: {
              auth: true,
              isEditor: true,
              resource: '/settings/smartdrive/:id',
              parentName: 'Smart Drive',
            },
          },
          ...(showSmartControl ? [
            {
              path: 'smart_control',
              name: 'SmartControl',
              component: SmartControl,
              meta: {
                auth: true,
                parentName: rootRoute.name,
                resource: '/settings/smartdrive/smart_control',
              },
            },
            {
              path: 'smart_control/:id',
              component: SmartControlManage,
              name: 'SmartControlManage',
              meta: {
                auth: true,
                isEditor: true,
                resource: '/settings/smartdrive/smart_control/:number',
                parentName: 'SmartControl',
              },
            },
            {
              path: 'rules',
              name: 'Rules',
              props: true,
              component: Rules,
              meta: {
                auth: true,
                resource: '/settings/smartdrive/rules',
                parentName: 'Smart Control',
              },
            },
            {
              path: 'rules/:id',
              component: ManageRules,
              name: 'ManageRule',
              meta: {
                auth: true,
                isEditor: true,
                resource: '/settings/smartdrive/rules/:number',
                parentName: 'Rules',
              },

            },
          ] : []),
        ],
      },
    ] : []),
    {
      path: 'documents',
      name: 'Documents',
      component: Documents,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'documents/:id',
      component: DocumentEditor,
      meta: {
        auth: true,
        resource: '/settings/documents/:id',
        parentName: 'Documents',
      },
    },
    IntegrationRouter,
    {
      path: 'apis',
      name: 'APIs',
      component: Apis,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    },
    {
      path: 'import',
      name: 'Import',
      component: Import,
      meta: {
        auth: true,
        resource: '/settings/import',
        parentName: rootRoute.name,
      },
    },
    ...(showCampaign ? [{
      path: 'campaigns',
      name: 'Campaign',
      component: Campaign,
      meta: {
        auth: true,
        parentName: rootRoute.name,
      },
    }] : []),
    {
      path: 'campaigns/:id',
      component: CampaignEditor,
      meta: {
        auth: true,
        resource: '/settings/campaigns/:id',
        parentName: 'Campaign',
      },
    },
  ],
};
